import { render } from "./AllocationEditor.vue?vue&type=template&id=60a3f765&scoped=true"
import script from "./AllocationEditor.vue?vue&type=script&lang=js"
export * from "./AllocationEditor.vue?vue&type=script&lang=js"

import "./AllocationEditor.vue?vue&type=style&index=0&id=60a3f765&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a3f765"]])

export default __exports__